import { Text, useColorModeValue } from "@chakra-ui/react";

function Heading({ children, ...props }) {
  const textColor = useColorModeValue("#2A2F33", "#fff");

  return (
    <Text color={textColor} fontWeight="700" fontSize={"1.7em"} {...props}>
      {children}
    </Text>
  );
}

export default Heading;
